export const CYS = process.env.REACT_APP_SECRET_KEY || "jger8reterfgr7rtrthi90xoe827eudm23ey23gygbnrgoeyfw8e7tr37fbiufwte2tdlkwru0wurtbigtrerhshshs";
